/** 仅按明确的技术故障文本分类；身份选择、缺资料、扫码和付款仍属于流程暂停。 */
export function isTechnicalPause(reason: string): boolean {
  return /自主恢复工具诊断异常|unsupported screen resolution|屏幕分辨率不支持|屏幕分辨率不受支持|浏览器窗口尺寸|ECONNREFUSED|ERR_CONNECTION_REFUSED|ERR_NAME_NOT_RESOLVED|CDP.{0,30}(断开|连接失败|disconnected)|Gateway.{0,30}(连接失败|不可用|disconnected)/i.test(reason);
}
